import { render, staticRenderFns } from "./AssetsScadaIndex.vue?vue&type=template&id=1bb42048&scoped=true"
import script from "./AssetsScadaIndex.vue?vue&type=script&lang=js"
export * from "./AssetsScadaIndex.vue?vue&type=script&lang=js"
import style0 from "./AssetsScadaIndex.vue?vue&type=style&index=0&id=1bb42048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb42048",
  null
  
)

export default component.exports